import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import "./UserMocks.css";

const MockDetails = () => {
  const { mockId } = useParams();
  const navigate = useNavigate();
  const [details, setDetails] = useState(null);
  const lang = localStorage.getItem("lang") === "bn" ? "bn" : "en";

  useEffect(() => {
    const fetchDetails = async () => {
      const token = localStorage.getItem("jwtToken");
      const res = await fetch(`${process.env.REACT_APP_API_URL}/mock_details`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ mock_id: mockId }),
      });
      const data = await res.json();
      if (!data.error) setDetails(data.data);
    };

    fetchDetails();
  }, [mockId]);

  if (!details) return <div className="usr-mock-loading">Loading...</div>;

  return (
    <div className="usr-mock-details">
      <div className="usr-mock-header">
        <button onClick={() => navigate(-1)} className="usr-mock-back-button">
          Back
        </button>
        <div>
          <h2 className="usr-mock-title">Mock ID: {details.mock_id}</h2>
          <div className="usr-mock-score">Score: {details.score}</div>
          <div className="usr-mock-date">
            Date: {new Date(details.created_at).toLocaleString()}
          </div>
        </div>
      </div>
      <ul className="usr-mock-question-list">
        {details.questions.map((q, index) => (
          <li
            key={index}
            className={`usr-mock-question-item ${
              q.is_correct ? "usr-mock-correct-bg" : "usr-mock-wrong-bg"
            }`}
          >
            <p>
              <strong>Q:</strong> {q.question_text}
              {lang === "bn" && (
                <span className="usr-mock-bn">
                  {" "}
                  Bangla: {q.question_text_bangla}
                </span>
              )}
            </p>
            {q.image && (
              <img src={q.image} alt="question" className="usr-mock-image" />
            )}
            <p>
              <strong>Your Answer:</strong>{" "}
              {q.user_answer || "No answer provided"}
              {lang === "bn" && q.user_answer_bangla && (
                <span className="usr-mock-bn">
                  {" "}
                  Bangla: {q.user_answer_bangla}
                </span>
              )}
            </p>
            <p>
              <strong>Correct Answer:</strong> {q.correct_answer}
              {lang === "bn" && q.correct_answer_bangla && (
                <span className="usr-mock-bn">
                  {" "}
                  Bangla: {q.correct_answer_bangla}
                </span>
              )}
            </p>
            <p className="usr-mock-status">
              {q.is_correct ? "Correct" : "Incorrect"}
            </p>
            <p>
              <strong>Explanation:</strong> {q.explanation}
              {lang === "bn" && q.explanation_bangla && (
                <span className="usr-mock-bn">
                  {" "}
                  Bangla: {q.explanation_bangla}
                </span>
              )}
            </p>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default MockDetails;
